import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 – Reconexión Postparto',
    desc: 'Volvé a tu cuerpo sin miedo'
  }, {
    emoji: '📗',
    title: 'Tomo 2 – Activación y Hábito',
    desc: 'Creá constancia real'
  }, {
    emoji: '📙',
    title: 'Tomo 3 – Fuerza Inicial',
    desc: 'Empezá a tonificar'
  }, {
    emoji: '📕',
    title: 'Tomo 4 – Quema y Energía',
    desc: 'Activá tu metabolismo'
  }, {
    emoji: '📓',
    title: 'Tomo 5 – Esculpir y Definir',
    desc: 'Resultados visibles'
  }, {
    emoji: '📔',
    title: 'Tomo 6 – Mantenimiento Anual',
    desc: 'Tu sistema para todo el año'
  }];
  const includes = ['Rutinas listas paso a paso', 'Sistema semanal armado', 'Opciones principiante/intermedio', 'Explicación simple de ejercicios', 'Mentalidad y motivación', 'Organización real para mamás', 'Seguimiento y progreso'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-288">
      <div className="text-center mb-16" data-id="element-289">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-4 flex items-center justify-center gap-3 text-gray-900" data-id="element-290">
          <span data-id="element-291">📘</span> 6 TOMOS COMPLETOS
        </h2>
        <div className="inline-block bg-pink-50 border border-pink-200 rounded-full px-6 py-2 mt-4" data-id="element-292">
          <p className="text-brand-accent font-semibold tracking-wide flex items-center gap-2" data-id="element-293">
            <span data-id="element-294">🧩</span> SISTEMA PROGRESIVO REAL
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-295">
        {tomos.map((tomo, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-pink-200 rounded-2xl p-6 hover:border-pink-300 transition-colors group shadow-sm" data-id="element-296">
            <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-297">
              {tomo.emoji}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-298">
              {tomo.title}
            </h3>
            <p className="text-gray-500" data-id="element-299">{tomo.desc}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-gradient-to-br from-white to-pink-50 border border-pink-200 rounded-3xl p-8 md:p-12 max-w-4xl mx-auto relative overflow-hidden shadow-lg" data-id="element-300">
        <div className="absolute top-0 right-0 w-64 h-64 bg-pink-100 blur-[80px] rounded-full pointer-events-none" data-id="element-301" />

        <h3 className="text-2xl md:text-3xl font-bold mb-8 flex items-center gap-3 text-gray-900" data-id="element-302">
          <span data-id="element-303">💎</span> Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-304">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-305">
              <CheckCircle2 className="text-brand-success flex-shrink-0 mt-1" size={20} data-id="element-306" />
              <span className="text-gray-600 text-lg" data-id="element-307">{item}</span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}